// extracted by mini-css-extract-plugin
export default {"row":"profile_row__NjLfS","card":"profile_card__scoH3"};